import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ModulePortalInfo } from '../model/moduleportal';
import { GlobalService } from '../service/global.service';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.css']
})
export class PortalComponent implements OnInit {
  empname: string;
  _EmpRole: string;
  baseurl: string;
  ModulePortalList: ModulePortalInfo[]
  constructor(private httpClient: HttpClient, private router: Router, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;
    
  }

  async ngOnInit() {
 
    this.empname = localStorage.getItem("EmpName_TH");
    this._EmpRole = localStorage.getItem("EmpRoleCode");

    var auth_token = await this.TokenService.RefreshToken();
    
    this.LoadModulePortal(auth_token)
      .then(data => {
        this.ModulePortalList = data;
      }).catch(response => {
        if (!response.ok) {
          this.TokenService.RedirectToLogin();
        }
      });
    
  }

  LoadModulePortal(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

     
    var objectjson = {};
    objectjson['ModulePortalEmpRole'] = this._EmpRole;
    objectjson['ModulePortalFlagActive'] = "Y";
    objectjson['ModulePortalFlagDelete'] = "N";
     
    let strjson = JSON.stringify(objectjson);

    return this.httpClient
      .post<ModulePortalInfo[]>(this.baseurl + "ModulePortal/GetModulePortal",
        strjson, httpOptions)
      .toPromise()

  }
  LinkRouter(moduleId) {
    this.router.navigate(["/MenuPortal",{ ModulePortalId: moduleId }])
  }
  btnTimeSheet() {
    this.router.navigate(['/time-sheet']);
  }
}
